import { SERVER_ADDRESS } from "../server";

export const mediaUrl = (path?: string | null): string => {
  const value = path?.trim();
  if (!value) return "";
  return /^(https?:\/\/|\/)/i.test(value) ? value : `${SERVER_ADDRESS}openfile/${value}`;
};
